$( document ).ready(function() {
  
  if($(".template-product").length > 0){
    
    $(".box--Custom-properties").on("change", "select", function(e){
      var value = $(this).val();
      $(this).parents(".box--Custom-properties").find(".variant-label-option-value").text(value)
    });
    
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= $(".product-single__add-to-cart .btn--add-to-cart").offset().top) {
            $(".btn--add-to-cart-custom").addClass("is-active");
        } else{
            $(".btn--add-to-cart-custom").removeClass("is-active"); 
        }
    });
  
    $(".product-section").on("click", ".btn--add-to-cart-custom", function(e){
      e.preventDefault();
      $( ".Custom__properties-select .select__select" ).each(function() {    
        $( ".btn--add-to-cart" ).trigger( "click" );
        if( $( this ).val() == null){
          $('html,body').animate({
              scrollTop: $(".product-single__meta").offset().top
          },'slow');
        }
        
      });
    });
  
    $(".dbtfy-upsell_bundles ").on("change", ".Custom__properties_upsell .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      $this.removeClass("invalid");
      $this.parents(".Custom__properties-select").find(".error").removeClass("is-error");
      var value = $this.val();
      
      var html = `<option value="" selected="" disabled="">${Translations.choose_one}</option>`;
      if($(this).data("id") == "brand"){
        $this.parents(".Custom__properties_upsell").find(".Custom__properties-label_value").text(value);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name', `properties[${value} Model]`);
        $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").attr('name-properties', `${value} Model`);
        Models.forEach(function(model){
          if(value == model.Brand){
            model.Models.split(/[,]+/).map(function(item){
              return html += `
                <option value="${item}">${item}</option>
              `
            })   
            $this.parents(".Custom__properties_upsell").find(".select__select[data-id='model']").html(html)
          }
        })
        
      }
    });

    $(".template-product ").on("change", " .Custom__properties-select .select__select", function(e){
      var $this = $(this);
      var ID = $this.parents(".Custom__properties-select").data("id");
      if(ID == "car-make"){
        $this.parents(".Custom__properties-select").siblings().fadeIn();
      }
    });


    $(".template-product ").on("click", " .product-single__add-to-cart .btn--add-to-cart", function(e){
      var $this = $(this);
      var tempOject = {};
      var checkValue = false
      var title = $this.parents(".product-single__meta").find(".product-single__title").text().trim();
      var number_of_seats = $this.parents(".product-single__meta").find("#SingleOptionSelector-1").val();
      var color = $this.parents(".product-single__meta").find(".swatch .input-color_swatches:checked").val();
      $this.parents(".product-single__form").find(".box--Custom__properties .select__select").each(function( index ) {
        var name = $(this).attr("name-properties");
        var value = $(this).val();
        if(value != null){
          checkValue = true
        }
        tempOject[name] = value
      });
      if(checkValue){
        var tempnoteOrder = localStorage.getItem("noteOrder");
        if(tempnoteOrder == null){
          localStorage.setItem("noteOrder", "");
        }
        var noteOrder = localStorage.getItem("noteOrder");
        var convertempOject = JSON.stringify(tempOject);
        if(typeof number_of_seats == "undefined"){
          var noteProduct = `${title} -- ${color}:${convertempOject}`;
        } else {
          var noteProduct = `${title} -- ${color} / ${number_of_seats}:${convertempOject}`;
        }
        
        if(noteOrder == ""){
          newNoteOrder = `${noteProduct}`;
        } else {
          newNoteOrder = `${noteOrder};${noteProduct}`;
        }       
        localStorage.setItem("noteOrder", newNoteOrder);   
        setTimeout(() => {
         $("#CartSpecialInstructions").val(newNoteOrder)
        }, 3500);
      }
    });
  }

  $("body").on("click", " .cart__product-remove", function(e){  
    e.preventDefault();
    var array = localStorage.getItem("noteOrder");
    var newArr = array.split(';');
    var valuesToRemove = $(this).parents(".cart__product-name").find(".title").data("title");
    newArr.forEach((item)=>{
      const checkValue = item.includes(valuesToRemove);
      if (checkValue) { // only splice array when item is found
        const index = newArr.indexOf(item);
        newArr.splice(index, 1); // 2nd parameter means remove one item only
      }
    })
    if(newArr.length == 0){
      var convertempArr = "";
    } else {
      var convertempArr = newArr.join(";");
    }    
    localStorage.setItem("noteOrder", convertempArr);
    setTimeout(() => {
      $(".cart__note textarea").val(convertempArr)
    }, 1500);
    
  });
  if($(".template-cart").length > 0){
    var noteCart = localStorage.getItem("noteOrder");
    $(".cart__note textarea").val(noteCart)
    $(".cart-form").on("click", " .cart__checkout", function(e){
      localStorage.removeItem("noteOrder");      
    });
     $(".template-cart").on("change", ".card-footer--checkbox #card-footer--input", function(e){
      var ID = $(this).data("id");
      if($(this).is(":checked")){
        $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: {
              quantity: 1,
              id: ID
           },
           dataType: 'json',
           success: function (data) {
              let cart = jQuery.getJSON('/cart.js');            
              cart.done(function(){
                cart = cart.responseJSON;
                let items = cart.items;
                addCompareAtPrice(cart);               
              })
              function addCompareAtPrice(cart) {
                  cart.items.forEach(function(item) {
                      $.ajax({
                          url: '/products/' + item.handle + '.js',
                          dataType: 'json',
                          async: false,
                          success: function(product) {
                              item["compare_at_price"] = 0;
                              product.variants.forEach(function(variant) {
                                  if (variant.compare_at_price != null && variant.id == item.variant_id) {
                                      item["compare_at_price"] = variant.compare_at_price;
                                  }
                              });
                          }
                      });
                      console.log(item["compare_at_price"])
                  });
                  
                  return cart;
              }
           }
        });        
      } else {
        $.ajax({
           type: 'POST',
           url: '/cart/change.js',
           data: {
              quantity: 0,
              id: ID
           },
           dataType: 'json',
           success: function (data) {

           }
        });
      }
    });
  }

  (function initCartLineEditors() {
    var cartLineModal = null;
    var currentEditingLine = null;
    var modelsBySourceCache = {};

    function getCart() {
      return fetch("/cart.js", {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function(response) {
        return response.json();
      });
    }

    function postJSON(url, payload) {
      return fetch(url, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      }).then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            throw new Error((data && data.description) || "Cart update failed.");
          }

          return data;
        });
      });
    }

    function getLineByKey(cart, key) {
      if (!cart || !cart.items || !cart.items.length) {
        return null;
      }

      return cart.items.find(function(item) {
        return item.key === key;
      }) || null;
    }

    function updateCartBadges(cart) {
      if (!cart) {
        return;
      }

      var itemCount = cart.item_count || 0;
      var totalPrice = cart.total_price || 0;
      var moneyFormat = (window.theme && theme.strings && theme.strings.moneyFormat) ? theme.strings.moneyFormat : "$";

      $(".cart-count").each(function() {
        $(this).text(itemCount <= 99 ? itemCount : "99+");
      });

      $(".cart-cost").each(function() {
        if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
          $(this).html('<span class="money">' + theme.Currency.formatMoney(totalPrice, moneyFormat) + "</span>");
        }
      });
    }

    function refreshCartUI() {
      return getCart().then(function(cart) {
        if (window.theme) {
          theme.cart = cart;
        }

        var hasDrawerContainer = !!document.querySelector("#CartContainer");
        var canUseThemeAjaxCart = window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === "function" && hasDrawerContainer;

        if (canUseThemeAjaxCart) {
          return new Promise(function(resolve) {
            try {
              theme.ajaxCart.update(function() {
                resolve();
              });
            } catch (e) {
              resolve();
            }
          });
        }

        if (document.body.classList.contains("template-cart")) {
          return fetch("/cart?view=ajax-page", {
            credentials: "same-origin",
            headers: { "Accept": "text/html" }
          }).then(function(response) {
            return response.text();
          }).then(function(markup) {
            var $mainContent = $(".main-content");

            if ($mainContent.length) {
              $mainContent.html(markup);
            }

            updateCartBadges(cart);
            $("body").trigger("ajaxCart.afterCartLoad", [cart, "page"]);
          });
        }

        updateCartBadges(cart);
      });
    }

    function setLineLoading($lineItem, isLoading) {
      if (!$lineItem || !$lineItem.length) {
        return;
      }

      $lineItem.toggleClass("is-loading", !!isLoading);
      $lineItem.find("[data-cart-line-variant-select], [data-cart-line-properties-edit]").prop("disabled", !!isLoading);
    }

    function setFeedback($lineItem, message, isError) {
      if (!$lineItem || !$lineItem.length) {
        return;
      }

      var $feedback = $lineItem.find("[data-cart-line-feedback]").first();

      if (!$feedback.length) {
        return;
      }

      $feedback.text(message || "");
      $feedback.toggleClass("text-sale", !!isError);
      $feedback.toggleClass("text-secondary", !isError);
    }

    function sanitizeProperties(properties) {
      var sanitized = {};
      var source = properties || {};

      Object.keys(source).forEach(function(key) {
        var value = source[key];
        var isNumericKey = /^\d+$/.test(String(key));

        if (isNumericKey) {
          return;
        }

        if (Array.isArray(value)) {
          return;
        }

        sanitized[key] = value;
      });

      return sanitized;
    }

    function normalizeCanonicalPropertyKeys(properties) {
      var normalized = {};
      var source = properties || {};
      var modelValue = "";

      Object.keys(source).forEach(function(key) {
        if (/model/i.test(String(key))) {
          if (!modelValue && source[key]) {
            modelValue = source[key];
          }

          return;
        }

        normalized[key] = source[key];
      });

      if (modelValue) {
        normalized.Model = modelValue;
      }

      return normalized;
    }

    function getYearOptions() {
      var options = [];
      var startYear = Math.max(new Date().getFullYear() + 1, 2026);
      var endYear = 1980;

      for (var year = startYear; year >= endYear; year -= 1) {
        options.push(String(year));
      }

      return options;
    }

    function getPropertySourceType($lineItem) {
      var templateSuffix = String($lineItem.data("product-template-suffix") || "").trim().toLowerCase();
      var tagsRaw = String($lineItem.data("product-tags") || "");
      var tags = tagsRaw.split("||").map(function(tag) {
        return String(tag || "").trim().toLowerCase();
      });

      // Prefer product template suffix over tags.
      if (templateSuffix) {
        if (templateSuffix.indexOf("steering-wheel") >= 0 || templateSuffix.indexOf("steering_wheel") >= 0) {
          return "steering-wheel";
        }

        if (templateSuffix.indexOf("mat") >= 0) {
          return "mat";
        }

        if (templateSuffix.indexOf("seat") >= 0) {
          return "seat";
        }

        if (templateSuffix.indexOf("taplo") >= 0) {
          return "taplo";
        }

        if (templateSuffix.indexOf("tpe") >= 0) {
          return "tpe";
        }
      }

      if (tags.indexOf("steering wheel") >= 0) {
        return "steering-wheel";
      }

      if (tags.indexOf("mat") >= 0) {
        return "mat";
      }

      if (tags.indexOf("seat") >= 0) {
        return "seat";
      }

      if (tags.indexOf("taplo") >= 0) {
        return "taplo";
      }

      if (tags.indexOf("tpe") >= 0) {
        return "tpe";
      }

      return "default";
    }

    function getPropertySourceContainer(sourceType) {
      return $(".cart-custom-properties-source[data-properties-source='" + sourceType + "']");
    }

    function parseModelsFromSource(sourceType) {
      if (modelsBySourceCache[sourceType]) {
        return modelsBySourceCache[sourceType];
      }

      var parsed = [];
      var $source = getPropertySourceContainer(sourceType);

      $source.find("script").each(function() {
        var scriptContent = $(this).text();
        var regex = /Models\.push\(\s*(\{[\s\S]*?\})\s*\)/g;
        var match;

        while ((match = regex.exec(scriptContent)) !== null) {
          try {
            parsed.push(JSON.parse(match[1]));
          } catch (e) {
          }
        }
      });

      modelsBySourceCache[sourceType] = parsed;
      return parsed;
    }

    function getBrandsFromModels(sourceType) {
      var parsedModels = parseModelsFromSource(sourceType);

      if (parsedModels.length) {
        return parsedModels.map(function(item) {
          return item.Brand;
        }).filter(Boolean);
      }

      var brands = [];

      getPropertySourceContainer(sourceType).find("select[data-id='brand'] option").each(function() {
        var value = $(this).attr("value");

        if (value) {
          brands.push(value);
        }
      });

      return brands;
    }

    function getModelsByBrand(brand, sourceType) {
      var parsedModels = parseModelsFromSource(sourceType);

      if (parsedModels.length && brand) {
        var matched = parsedModels.find(function(item) {
          return item.Brand === brand;
        });

        if (matched && matched.Models) {
          return matched.Models.split(",").map(function(item) {
            return item.trim();
          }).filter(Boolean);
        }
      }

      var fallbackModels = [];

      getPropertySourceContainer(sourceType).find("select[data-id='model'] option").each(function() {
        var value = $(this).attr("value");

        if (value) {
          fallbackModels.push(value);
        }
      });

      return fallbackModels;
    }

    function detectPropertyKeys(properties) {
      var keys = Object.keys(properties || {});
      var cleanKeys = keys.filter(function(key) {
        return !/^\d+$/.test(String(key));
      });

      var makeKey = cleanKeys.find(function(key) { return key.toLowerCase() === "car make"; }) || cleanKeys.find(function(key) { return key.toLowerCase().indexOf("make") >= 0; }) || "Car Make";
      var yearKey = cleanKeys.find(function(key) { return key.toLowerCase() === "car year"; }) || cleanKeys.find(function(key) { return key.toLowerCase().indexOf("year") >= 0; }) || "Car Year";
      var modelKey = cleanKeys.find(function(key) { return key.toLowerCase() === "model"; }) || cleanKeys.find(function(key) { return key.toLowerCase().indexOf("model") >= 0; }) || "Model";

      return {
        makeKey: makeKey,
        modelKey: modelKey,
        yearKey: yearKey
      };
    }

    function ensureCartLineModal() {
      if (cartLineModal) {
        return cartLineModal;
      }

      var modalHtml = '' +
        '<div class="cart-line-editor-modal" data-cart-line-modal style="display:none; position:fixed; inset:0; z-index:9999; background:rgba(0,0,0,0.45);">' +
        '  <div style="background:#fff; max-width:560px; width:calc(100% - 30px); margin:6vh auto; border-radius:8px; padding:20px; max-height:88vh; overflow:auto;">' +
        '    <div class="flex justify-between align-center spacer-bottom-sm">' +
        '      <h3 class="h5 spacer-bottom-none">Edit Custom Details</h3>' +
        '      <button type="button" class="btn btn-square-small" data-cart-line-modal-close>×</button>' +
        '    </div>' +
        '    <div data-cart-line-modal-fields></div>' +
        '    <div class="spacer-top-sm flex" style="gap:10px;">' +
        '      <button type="button" class="btn btn--primary" data-cart-line-modal-save>Save</button>' +
        '      <button type="button" class="btn" data-cart-line-modal-close>Cancel</button>' +
        '    </div>' +
        '    <p class="text-small text-sale spacer-top-xs" data-cart-line-modal-error></p>' +
        '  </div>' +
        '</div>';

      $("body").append(modalHtml);
      cartLineModal = $("[data-cart-line-modal]");
      return cartLineModal;
    }

    function escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    function renderSelect(label, key, values, selectedValue, role) {
      var options = ['<option value="" disabled>Choose one</option>'];
      var roleAttr = role ? ' data-popup-role="' + role + '"' : "";

      (values || []).forEach(function(value) {
        var isSelected = String(value) === String(selectedValue);
        options.push('<option value="' + escapeHtml(value) + '"' + (isSelected ? " selected" : "") + ">" + escapeHtml(value) + "</option>");
      });

      return '' +
        '<div class="spacer-top-xs">' +
        '  <label class="text-small">' + escapeHtml(label) + '</label>' +
        '  <select class="input-full" data-popup-property-key="' + escapeHtml(key) + '"' + roleAttr + '>' + options.join("") + "</select>" +
        "</div>";
    }

    function renderInput(label, key, value, role) {
      var roleAttr = role ? ' data-popup-role="' + role + '"' : "";

      return '' +
        '<div class="spacer-top-xs">' +
        '  <label class="text-small">' + escapeHtml(label) + '</label>' +
        '  <input class="input-full" type="text" data-popup-property-key="' + escapeHtml(key) + '"' + roleAttr + ' value="' + escapeHtml(value || "") + '">' +
        "</div>";
    }

    function buildPopupFields(properties, sourceType) {
      var keys = detectPropertyKeys(properties);
      var makeValue = properties[keys.makeKey] || "";
      var modelValue = properties[keys.modelKey] || "";
      var yearValue = properties[keys.yearKey] || "";
      var brands = getBrandsFromModels(sourceType);
      var models = getModelsByBrand(makeValue, sourceType);
      var years = getYearOptions();
      var html = "";

      if (brands.length) {
        html += renderSelect(keys.makeKey, keys.makeKey, brands, makeValue, "make");
      } else {
        html += renderInput(keys.makeKey, keys.makeKey, makeValue, "make");
      }

      if (models.length) {
        html += renderSelect(keys.modelKey, keys.modelKey, models, modelValue, "model");
      } else {
        html += renderInput(keys.modelKey, keys.modelKey, modelValue, "model");
      }

      html += renderSelect(keys.yearKey, keys.yearKey, years, yearValue, "year");

      Object.keys(properties).forEach(function(key) {
        var isSpecial = key === keys.makeKey || key === keys.modelKey || key === keys.yearKey || /^\d+$/.test(String(key));

        if (!isSpecial) {
          html += renderInput(key, key, properties[key]);
        }
      });

      return html;
    }

    function openPropertiesPopup($lineItem) {
      var $modal = ensureCartLineModal();
      var lineItemKey = $lineItem.data("line-item-key");

      if (!lineItemKey) {
        return;
      }

      var raw = $lineItem.find("[data-cart-line-properties-json]").first().text();
      var properties = {};
      var sourceType = getPropertySourceType($lineItem);

      try {
        properties = sanitizeProperties(JSON.parse(raw || "{}"));
      } catch (e) {
        properties = {};
      }

      currentEditingLine = {
        $lineItem: $lineItem,
        lineItemKey: lineItemKey,
        properties: properties,
        sourceType: sourceType
      };

      $modal.find("[data-cart-line-modal-fields]").html(buildPopupFields(properties, sourceType));
      $modal.find("[data-cart-line-modal-error]").text("");
      $modal.show();
    }

    function closePropertiesPopup() {
      var $modal = ensureCartLineModal();
      $modal.hide();
      $modal.find("[data-cart-line-modal-error]").text("");
    }

    function collectPopupProperties() {
      var result = {};

      ensureCartLineModal().find("[data-popup-property-key]").each(function() {
        var key = $(this).data("popup-property-key");

        if (typeof key !== "undefined") {
          result[key] = $(this).val();
        }
      });

      return sanitizeProperties(result);
    }

    function updateProperties(lineItemKey, properties) {
      return getCart().then(function(cart) {
        var line = getLineByKey(cart, lineItemKey);

        if (!line) {
          throw new Error("Line item was not found.");
        }

        var mergedProperties = Object.assign({}, line.properties || {}, properties || {});
        mergedProperties = sanitizeProperties(mergedProperties);
        mergedProperties = normalizeCanonicalPropertyKeys(mergedProperties);

        return postJSON("/cart/change.js", {
          id: lineItemKey,
          quantity: line.quantity,
          properties: mergedProperties
        });
      }).then(function() {
        return refreshCartUI();
      });
    }

    function updateVariant(lineItemKey, newVariantId) {
      var originalLine;

      return getCart().then(function(cart) {
        originalLine = getLineByKey(cart, lineItemKey);

        if (!originalLine) {
          throw new Error("Line item was not found.");
        }

        return fetch("/products/" + originalLine.handle + ".js", {
          credentials: "same-origin",
          headers: { "Accept": "application/json" }
        }).then(function(response) {
          return response.json();
        });
      }).then(function(product) {
        var nextVariant = (product.variants || []).find(function(variant) {
          return String(variant.id) === String(newVariantId);
        });

        if (!nextVariant) {
          throw new Error("Variant was not found.");
        }

        if (!nextVariant.available) {
          throw new Error("This variant is unavailable.");
        }

        return postJSON("/cart/add.js", {
          items: [{
            id: newVariantId,
            quantity: originalLine.quantity,
            properties: originalLine.properties || {}
          }]
        });
      }).then(function() {
        return postJSON("/cart/change.js", {
          id: lineItemKey,
          quantity: 0
        });
      }).then(function() {
        return refreshCartUI();
      });
    }

    window.updateVariant = updateVariant;
    window.updateProperties = updateProperties;

    $("body").on("change", "[data-cart-line-variant-select]", function() {
      var $select = $(this);
      var $lineItem = $select.closest(".cart-item");
      var lineItemKey = $lineItem.data("line-item-key");
      var currentVariantId = String($lineItem.data("current-variant-id"));
      var newVariantId = String($select.val());

      if (!lineItemKey || !newVariantId || newVariantId === currentVariantId) {
        return;
      }

      setFeedback($lineItem, "", false);
      setLineLoading($lineItem, true);

      updateVariant(lineItemKey, newVariantId).then(function() {
        setLineLoading($lineItem, false);
      }).catch(function(error) {
        $select.val(currentVariantId);
        setFeedback($lineItem, (error && error.message) ? error.message : "Variant update failed.", true);
        setLineLoading($lineItem, false);
      });
    });

    $("body").on("click", "[data-cart-line-properties-edit]", function() {
      openPropertiesPopup($(this).closest(".cart-item"));
    });

    $("body").on("click", "[data-cart-line-modal-close]", function() {
      closePropertiesPopup();
    });

    $("body").on("click", "[data-cart-line-modal]", function(e) {
      if (e.target === this) {
        closePropertiesPopup();
      }
    });

    $("body").on("change", "[data-popup-role='make']", function() {
      var brand = $(this).val();
      var sourceType = currentEditingLine && currentEditingLine.sourceType ? currentEditingLine.sourceType : "default";
      var models = getModelsByBrand(brand, sourceType);
      var modelSelect = $("[data-popup-role='model']");

      if (!modelSelect.length || !models.length || !modelSelect.is("select")) {
        return;
      }

      var options = ['<option value="" selected disabled>Choose one</option>'];
      models.forEach(function(model) {
        options.push('<option value="' + escapeHtml(model) + '">' + escapeHtml(model) + "</option>");
      });

      modelSelect.html(options.join(""));
    });

    $("body").on("click", "[data-cart-line-modal-save]", function() {
      if (!currentEditingLine || !currentEditingLine.lineItemKey) {
        return;
      }

      var $lineItem = currentEditingLine.$lineItem;
      var editedProperties = collectPopupProperties();

      setFeedback($lineItem, "", false);
      setLineLoading($lineItem, true);

      updateProperties(currentEditingLine.lineItemKey, editedProperties).then(function() {
        setFeedback($lineItem, "Details updated.", false);
        setLineLoading($lineItem, false);
        closePropertiesPopup();
      }).catch(function(error) {
        ensureCartLineModal().find("[data-cart-line-modal-error]").text((error && error.message) ? error.message : "Details update failed.");
        setFeedback($lineItem, (error && error.message) ? error.message : "Details update failed.", true);
        setLineLoading($lineItem, false);
      });
    });
  })();




  (function () {
    if (window.__carDetailsBuyNowValidation) return;
    window.__carDetailsBuyNowValidation = true;

    var fieldSelector = 'select[name="properties[Car Make]"], select[data-id="model"], select[name="properties[Car Year]"]';

    document.addEventListener('change', function (event) {
      if (!event.target.matches(fieldSelector) || !event.target.value) return;
      event.target.classList.remove('invalid');
      event.target.removeAttribute('aria-invalid');
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest('.shopify-payment-button__button') : null;
      if (!button) return;

      var form = button.closest('form');
      if (!form) return;

      var fields = Array.prototype.slice.call(form.querySelectorAll(fieldSelector));
      var invalidFields = fields.filter(function (field) {
        return !field.value || !field.checkValidity();
      });

      fields.forEach(function (field) {
        var invalid = invalidFields.indexOf(field) !== -1;
        field.classList.toggle('invalid', invalid);
        if (invalid) {
          field.setAttribute('aria-invalid', 'true');
        } else {
          field.removeAttribute('aria-invalid');
        }
      });

      if (!invalidFields.length) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      invalidFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      invalidFields[0].focus({ preventScroll: true });
      invalidFields[0].reportValidity();
    }, true);
  })();

});
